import { getPropertyFromGID, getReferenceIdFromGID, isGID } from "~/lib/shopify/utils/id"

export function processRevalidateTag(tag: string) {
  if (isGID(tag)) {
    return `${getPropertyFromGID(tag)}-${getReferenceIdFromGID(tag)}`
  }
  return tag
}
